import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ConfigProvider } from 'antd';
import zhCN from 'antd/lib/locale/zh_CN';
import ErrorBoundary from './components/ErrorBoundary';
import { AuthProvider } from './context/AuthContext';
import { ConsultationProvider } from './context/ConsultationContext';
import DebugConsole from './components/DebugConsole';
import { QianfangChatProvider } from './context/QianfangChatContext';

// 页面组件
import Login from './pages/Login';
import Register from './pages/Register';
import Home from './pages/Home';
import Consultation from './pages/Consultation';
import Result from './pages/Result';
import History from './pages/History';
import Profile from './pages/Profile';
import TestPage from './pages/TestPage';
import NoContextPage from './pages/NoContextPage';
import ApiTest from './pages/ApiTest';
import QianfangChat from './pages/QianfangChat';

// 上下文和钩子
import { useAuth } from './hooks/useAuth';

// 受保护的路由组件
const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, loading } = useAuth();
  
  console.log('ProtectedRoute:', { isAuthenticated, loading });
  
  try {
    if (loading) {
      return <div style={{ padding: '50px', textAlign: 'center' }}>加载中...</div>;
    }
    
    if (!isAuthenticated) {
      console.log('用户未认证，重定向到登录页面');
      return <Navigate to="/login" replace />;
    }
    
    console.log('用户已认证，显示受保护内容');
    return children;
  } catch (error) {
    console.error('ProtectedRoute错误:', error);
    return <Navigate to="/login" replace />;
  }
};

function App() {
  return (
    <ConfigProvider locale={zhCN}>
      <ErrorBoundary>
        <AuthProvider>
          <ConsultationProvider>
            <QianfangChatProvider>
              <Router>
                <Routes>
                  <Route path="/no-context" element={<NoContextPage />} />
                  <Route path="/api-test" element={<ApiTest />} />
                  <Route path="/test" element={<TestPage />} />
                  <Route path="/login" element={<Login />} />
                  <Route path="/register" element={<Register />} />
                  <Route path="/" element={
                    <ProtectedRoute>
                      <Home />
                    </ProtectedRoute>
                  } />
                  <Route path="/consultation" element={
                    <ProtectedRoute>
                      <Consultation />
                    </ProtectedRoute>
                  } />
                  <Route path="/result/:id" element={
                    <ProtectedRoute>
                      <Result />
                    </ProtectedRoute>
                  } />
                  <Route path="/history" element={
                    <ProtectedRoute>
                      <History />
                    </ProtectedRoute>
                  } />
                  <Route path="/profile" element={
                    <ProtectedRoute>
                      <Profile />
                    </ProtectedRoute>
                  } />
                  <Route path="/chat" element={
                    <QianfangChat />
                  } />
                  <Route path="*" element={<Navigate to="/login" replace />} />
                </Routes>
              </Router>
              {process.env.NODE_ENV === 'development' && <DebugConsole />}
            </QianfangChatProvider>
          </ConsultationProvider>
        </AuthProvider>
      </ErrorBoundary>
    </ConfigProvider>
  );
}

export default App;
